import React, { useEffect, useState } from "react";
import ReactGA from 'react-ga4';
import { IoSearchOutline } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import { languages } from "../utils/languageOption";
import { getMovies } from "../services/movieService";
import { actorLocalData } from "../utils/actors";
import { captureEvent } from "../services/analytics/eventCapture";


const Movies = () => {
	const navigate = useNavigate();
	const [videos, setVideos] = useState([]);
	const [selectedLanguage, setSelectedLanguage] = useState("Hindi");
	const [selectedActor, setSelectedActor] = useState("For You");
	const [languageFilter, setLanguageFilter] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");
	const [loading, setLoading] = useState(false);

	const fetchMovies = async (language, search, actor) => {
		try {
			setLoading(true);
			const data = await getMovies(language, search, actor);
			setVideos(data);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching movies:", error);
		}
	};
	
	useEffect(() => {
		ReactGA.send({ hitType: "pageview", page:'/movie', title: `Movie | Chimera | Euler Motors` })
		fetchMovies(null, null, null);
	}, []);

	const handleLanguageFilterClose = () => {
		if (languageFilter) {
			setLanguageFilter(!languageFilter);
		}
	};

	useEffect(() => {
		captureEvent("Movie", "Language", selectedLanguage)
		fetchMovies(selectedLanguage, null, null);
	}, [selectedLanguage]);

	const handleActorClick = (actor) => {
		captureEvent("Movie", "Actor", actor);
		setSearchTerm("");
		setSelectedActor(actor);

		if (actor === "For You") {
			fetchMovies(null, null, null);
		} else {
			fetchMovies(null, null, actor);
		}
	};
	const handleSearchChange = (e) => {
		setSearchTerm(e.target.value);
	};

	const searchMovie = () => {
		captureEvent("Movie", "Movie_Search", searchTerm)
		fetchMovies(null, searchTerm, null);
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			searchMovie();
		}
	};

	return (
		<div 
			className="w-[100vw] h-full screen-background flex flex-col overflow-x-hidden " 
			onClick={() => handleLanguageFilterClose()}
		>
			<div className="w-full screen-background flex flex-col px-5">
				{/* MENU SECTION */}
				<div className="flex flex-col w-full mx-auto screen-background z-[100] sticky top-0 left-0">
					{/* TITLE */}
					<div className="flex justify-between items-center w-full py-4">
						<div className="text-[#F8F9FA] font-[500] text-[32px]">
							Movies
						</div>
					</div>

					{/* SEARCH AND LANGUAGE FILTER */}
					<div className="w-full flex flex-row justify-between items-center py-1 xl:gap-3 transition-all duration-800 ease-in">
						<div className="w-[84%] xl:w-full flex flex-row items-center text-white relative">
							<div
								className="absolute left-5 cursor-pointer"
								onClick={() => searchMovie()}
							>
								<IoSearchOutline size={40} />
							</div>

							<input
								className="w-full px-20 py-5 bg-[#2E3134] rounded-[70px] text-[24px] font-[400] text-white outline-none"
								type="search"
								placeholder="Search"
								onChange={(e) => handleSearchChange(e)}
								onKeyDown={(e) => handleKeyDown(e)}
							/>
						</div>

						{/* LANGUAGE FILTER */}
						<div
							className="w-[15%] xl:w-fit flex flex-row gap-2 text-white bg-[#2E3134] p-5 rounded-[70px] justify-around items-center text-[24px] font-[400] cursor-pointer transition-all duration-800 ease-in"
							onClick={() => setLanguageFilter(!languageFilter)}
						>
							<div>{selectedLanguage}</div>
							<div>
								<IoIosArrowDown />
							</div>
						</div>

						<div
							className={`bg-[#2E3134] text-[80px] text-white py-3 mt-2 cursor-pointer rounded-lg absolute right-1 top-40 z-[10000] transition-all duration-800 ease-in ${
								languageFilter ? "block" : "hidden"
							}`}
						>
							<div className="flex flex-col justify-center items-center py-[8px]">
								{languages?.map((language) => (
									<div
										className={`flex flex-row w-full py-3 px-10 text-[20px] font-[400] ${
											selectedLanguage ===
											language?.language
												? "text-[#9CCDFB]"
												: "text-white"
										}`}
										onClick={() =>
											setSelectedLanguage(
												language.language
											)
										}
									>
										<div className="px-4">{language?.languageLogo}</div>
										<div>{language?.language}</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>


			<div className="flex flex-row overflow-x-scroll w-[100vw] slider-container px-5 py-4">
				{actorLocalData?.map((filter) => (			
					<div
						className={`flex flex-row justify-around items-center bg-[#2E3133] min-w-fit pl-2 pr-4 mr-4 py-6 rounded-[36px] cursor-pointer actor-btn ${
							selectedActor === filter.name
								? "text-[#9CCDFB] border-[2px] border-[#9CCDFB]"
								: "text-white"
							} ${filter.name === 'For You' ? 'width-fit h-full': ''}`
						}
						onClick={() =>
							handleActorClick(filter?.name)
						}
					>
						{filter.name !== 'For You' && <img src={filter.image} alt={filter.name} className="w-10 h-10 bg-white object-cover rounded-full"/>}
						<div className="text-[20px] pl-2 font-[400]">
							{filter.name}
						</div>
					</div>
								
							
				))}
			</div>

			{/* VIDEOS DISPLAY SECTION */}
			<div className="w-full h-full overflow-y-scroll scroll-container">
				{
					loading ? 
						<div className={`${loading ? 'w-full h-full flex flex-row justify-center items-center text-5xl font-bold text-white' : 'invisible w-0 h-0'}`}>
							<div className="spinner"></div>
						</div> 
						: videos?.length > 0 ? (
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full gap-x-[20px] gap-y-[16px] z-0 left-0 px-5 cursor-pointer">
							{videos?.map((video) => (
								<div
									className="flex flex-col gap-y-[12px] items-center relative image"
									onClick={() =>
										navigate(
											`/youtubeVideo/video/${video?.video_id?.videoId}`
										)
									}
								>
									<div className="w-full h-full">
										<img
											alt="movie-card"
											src={
												video?.snippet?.thumbnails?.high
													?.url
											}
											className="rounded-2xl w-full h-full"
										/>
									</div>
									<div className="text-white text-[24px] font-[500]">
										{video?.snippet?.title}
									</div>
								</div>
							))}
						</div>
					) : (
						<div className="w-full h-full flex flex-row justify-center items-center text-3xl text-white">
							No Movies Found !!
						</div>
					)
				}
			</div>
		</div>
	);
};

export default Movies;
